import { NgModule } from "@angular/core";
import * as Material from "@angular/material";
const MaterialComponents = [
  Material.MatAutocompleteModule,
  Material.MatButtonToggleModule,
  Material.MatChipsModule,
  Material.MatDatepickerModule,
  Material.MatDialogModule,
  Material.MatExpansionModule,
  Material.MatMenuModule,
  Material.MatNativeDateModule,
  Material.MatPaginatorModule,
  Material.MatProgressBarModule,
  Material.MatProgressSpinnerModule,
  Material.MatRadioModule,
  Material.MatRippleModule,
  Material.MatSelectModule,
  Material.MatSliderModule,
  Material.MatSlideToggleModule,
  Material.MatSnackBarModule,
  Material.MatSortModule,
  Material.MatTableModule,
  Material.MatTabsModule,
  Material.MatToolbarModule,
  Material.MatTooltipModule,
  Material.MatStepperModule,
  Material.MatButtonModule,
  Material.MatCheckboxModule,
  Material.MatIconModule,
  Material.MatSidenavModule,
  Material.MatListModule,
  Material.MatGridListModule,
  Material.MatFormFieldModule,
  Material.MatInputModule,
  Material.MatCardModule,
  Material.MatBadgeModule,
  Material.MatBottomSheetModule
];

@NgModule({
  imports: [MaterialComponents],
  exports: [MaterialComponents]
})
export class MaterialDesignModule { }
// import { NgModule } from '@angular/core';
// import * as MATERIAL_MODULES from '@angular/material';

// export function mapMaterialModules() {
//   return Object.keys(MATERIAL_MODULES).filter((k) => {
//     let asset = MATERIAL_MODULES[k];
//     return typeof asset == 'function'
//       && asset.name.startsWith('Mat')
//       && asset.name.includes('Module');
//   }).map((k) => MATERIAL_MODULES[k]);
// }
// const modules = mapMaterialModules();
// @NgModule({
//   imports: modules,
//   exports: modules
// })
// export class MaterialDesignModule { }